module.exports = __webpack_public_path__ + "static/media/love-drivelah-1.946bfc40.jpg";